import React, { useContext, useState, useEffect } from "react";
import { Icon, InputFieldWithLabel } from "../../../../../components";
import { Col, Row } from "../../../../../components/Grid";
import { Typography } from "../../../../../components/Typography";
import { AddedFields, AddedFieldsWrapper } from "./FieldList.styled";
import { DispatchPositionContext } from "../../../../context/PositionContext";

const FieldList = ({ name, list, label, max, addText, placeholder, description, positionId }) => {
  const positionDispatch = useContext(DispatchPositionContext);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue("");
  }, [positionId]);

  const handleAddNew = () => {
    if (inputValue.trim() !== "" && list.length < max) {
      const updatedList = [...list, inputValue];
      positionDispatch({
        type: "update_position_field",
        payload: [name, updatedList],
      });
      setInputValue("");
    }
  };

  const handleRemove = (index) => {
    const updatedList = list.filter((item, itemIndex) => itemIndex !== index);
    positionDispatch({
      type: "update_position_field",
      payload: [name, updatedList],
    });
  };

  return (
    <>
      <Row>
        <Col>
          <Typography tag="p" bold mt={24} nomargin mbXL="10">
            {label}
          </Typography>
          <Typography tag="p" lowOpacity mb="8" mt="4" mtLG="0" mbLG="0">
            {description}
          </Typography>
          <InputFieldWithLabel
            autoFocus
            maxLength="80"
            label={false}
            tiny
            value={inputValue}
            placeholder={placeholder}
            name={name}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleAddNew();
              }
            }}
          />
          <AddedFieldsWrapper>
            {list.map((item, index) => (
              <AddedFields key={index} index={index}>
                {item}
                <Icon icon="cross" scale="0.8" ml={8} onClick={() => handleRemove(index)} />
              </AddedFields>
            ))}
          </AddedFieldsWrapper>
        </Col>
      </Row>
    </>
  );
};

export default FieldList;
